export default __webpack_public_path__ + "static/media/new_ressources.ee354236.svg";